// src/utils/setBaseUrl.js

const resolveBaseUrl = () => {
    if (typeof window !== "undefined" && window.location) {
        const hostname = window.location.hostname;
        if (hostname && hostname !== "localhost" && hostname !== "127.0.0.1") {
            return `${window.location.origin}/`;
        }
    }
    if (process.env.REACT_APP_API_URL) {
        return process.env.REACT_APP_API_URL.endsWith("/")
            ? process.env.REACT_APP_API_URL
            : `${process.env.REACT_APP_API_URL}/`;
    }
    return "http://localhost:8000/";
};

let baseUrl = resolveBaseUrl();

export const setBaseUrl = (url) => {
    baseUrl = url;
};

export const getBaseUrl = () => {
    if (!baseUrl || (typeof window !== "undefined" && window.location && window.location.hostname !== "localhost" && window.location.hostname !== "127.0.0.1" && baseUrl.includes("localhost"))) {
        baseUrl = resolveBaseUrl();
    }
    return baseUrl;
};
